<script>
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";

	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { onMount } from "svelte";
	import client from "../../../services/client";
	import { loading } from "../../../store/store";
	import moment from "moment-timezone";

	let groupId = window.location.pathname.split(
		"/master-data/group/details/"
	)[1];

	let detailData = [];
	onMount(async () => {
		try {
			loading.set(true);
			const res = await client(`/v0/Group/Details/${groupId}`, {
				method: "GET",
				version: "Tasking",
			});
			detailData = res.data.data;
			loading.set(false);
		} catch (error) {
			loading.set(false);
		}
	});

	const trigerLoad = async () => {
		try {
			loading.set(true);
			const res = await client(`/v0/Group/Details/${groupId}`, {
				method: "GET",
				version: "Tasking",
			});
			detailData = res.data.data;
			loading.set(false);
		} catch (error) {
			loading.set(false);
		}
	};

	const trigerUnassign = async (status, id) => {
		try {
			loading.set(true);
			const response = await client(`/v0/Group/Update`, {
				method: "POST",
				version: "Tasking",
				data: {
					group: id,
					status,
				},
			});

			trigerLoad();
			loading.set(false);
		} catch (error) {
			loading.set(false);

			console.error(error.response);
		}
	};

	function convert(time) {
		let eventStartTime = moment
			.utc(time)
			.tz("Asia/Singapore")
			.format("DD MMM YYYY LTS");
		return eventStartTime;
	}
</script>

<Row class="card-detail">
	<Col xs={12}>
		<PageHeader title={detailData.name} />
	</Col>
	<Col>
		<Row class="my-3">
			<Col>Group ID</Col>
			<Col><b>{detailData.groupId}</b></Col>
		</Row>
		<Row class="my-3">
			<Col>
				<span> Status </span>
			</Col>
			<Col>
				{#if detailData.status}
					<b>Active</b>
				{:else}
					<b>Inactive</b>
				{/if}
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span> Created Date </span></Col>
			<Col><b>{convert(detailData.createdAt)}</b></Col>
		</Row>
		<Row class="pt-3 my-3" style="border-top: 1px solid gray">
			<Col
				><p>
					{#if detailData.status === false}
						<b
							on:keydown={() => {}}
							on:click={() =>
								trigerUnassign(true, detailData.groupId)}
							class="link-text"
						>
							Set group to active
						</b>
					{:else}
						<b
							on:keydown={() => {}}
							on:click={() =>
								trigerUnassign(false, detailData.groupId)}
							class="link-text"
						>
							Set group to inactive
						</b>
					{/if}
				</p></Col
			>
		</Row>
	</Col>
</Row>
